export default __webpack_public_path__ + "static/media/text2.854e777e.png";